import client from "./client";

export const fetchAllPartners = async () => {
  const response = await client.get("/partner/profiles", {});

  return response.data;
};